import {API_URL, authHeaders, jsonHeaders} from "./index";

export async function apiListUsers(sort) {
    const res = await fetch(`${API_URL}/admin/users?sort=${sort}`, {headers: authHeaders()});
    return res.json();
}

export async function apiBlockUser(id, blocked) {
    const res = await fetch(`${API_URL}/admin/users/${id}/block`, {
        method: "PATCH",
        headers: jsonHeaders(),
        body: JSON.stringify({blocked}),
    });
    return res.json();
}

export async function apiSetUserRole(id, role) {
    const res = await fetch(`${API_URL}/admin/users/${id}/role`, {
        method: "PATCH",
        headers: jsonHeaders(),
        body: JSON.stringify({role}),
    });
    return res.json();
}

export async function apiDeleteUser(id) {
    const res = await fetch(`${API_URL}/admin/users/${id}`, {
        method: "DELETE",
        headers: authHeaders(),
    });
    return res.json();
}

export async function apiVerifyUser(id) {
    const res = await fetch(`${API_URL}/admin/users/${id}/verify`, {
        method: "PATCH",
        headers: authHeaders(),
    });
    return res.json();
}

export async function apiPurgeUser(id) {
    const res = await fetch(`${API_URL}/admin/users/${id}/purge`, {
        method: "DELETE",
        headers: authHeaders(),
    });
    return res.json();
}

export async function apiCreateUser({email, password, role}) {
    const res = await fetch(`${API_URL}/admin/users`, {
        method: "POST",
        headers: jsonHeaders(),
        body: JSON.stringify({email, password, role}),
    });
    return res.json();
}
